import { render, staticRenderFns } from "./HongKongIndustryDialog.vue?vue&type=template&id=66185054"
import script from "./HongKongIndustryDialog.vue?vue&type=script&lang=js"
export * from "./HongKongIndustryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports